import { Analytics } from './analytics';

let asideMenuItemLink = $('[menu-item-link-aside-level-2]');
let asideMobileMenuItemLink = $('[mobile-menu-item-link-aside-level-2]');

asideMenuItemLink.click((e) => {
    let menu = $(e.target).closest('[aside-menu]').find('[menu-item-link-aside-level-1]').text();

    Analytics.sendEvent(menu, window.location.pathname, '')
});

asideMobileMenuItemLink.click((e) => {
    let menu = $(e.target).closest('[mobile-menu-item-link-aside]').find('[mobile-menu-item-link-aside-level-1]').text();

    Analytics.sendEvent(menu, window.location.pathname, '')
});